export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-8.4854eb60.png";